module.exports = __webpack_public_path__ + "img/food_savior_splash.30fa50b2.png";